import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { mapPageView } from 'tag-manager/page_view'
import { OembedHeader, Seo } from 'ui-components'

import { MapAccessRequest } from 'map-access/App/AccessRequest'
import { App as PointMapLayout, getMapSchema } from 'map-preview'
import { App as PolygonsMap, getServerSideProps } from 'map-viewer'

const authorization = (Component) => (props) => {
  if (!props.authorized) return <MapAccessRequest />
  return <Component {...props} />
}

const Map = authorization((props) => {
  const { og, mapId, userId, map, embedKey } = props || {}
  const router = useRouter()
  const baseUrl = og?.url?.split('/').slice(0, 3).join('/')
  const [schema, setSchema] = useState(null)

  const appProps = {
    og,
    mapId,
    map
  }

  useEffect(() => {
    // Fetch the map schema
    const fetchSchema = async () => {
      const schemaData = await getMapSchema(map, router, baseUrl)
      setSchema(schemaData as any)
    }

    fetchSchema()
  }, [map, router, baseUrl])

  useEffect(() => {
    mapPageView(map.id, map.name)
  }, [map])

  return (
    <>
      <Head>
        {schema && (
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(schema)
            }}
          />
        )}
      </Head>
      <OembedHeader
        baseUrl={baseUrl}
        title={og?.title}
        mapId={mapId}
        embedKey={embedKey}
      />
      <Seo {...og} />
      {map?.type === 'points' && (
        <PointMapLayout
          userId={userId}
          mapId={mapId}
          map={map}
        />
      )}
      {map?.type === 'polygons' && (
        <PolygonsMap
          key={mapId}
          {...appProps}
        />
      )}
    </>
  )
})

export { getServerSideProps }
export default Map
